export default __webpack_public_path__ + "static/revolutionize-a918ee22624956d4bddb0d2b75eb7b2a.png";